module.exports = __webpack_public_path__ + "img/virginislands.91d54dfb.svg";